<template>
  <div class="course-orders">
    <div class="card">
      <div class="card-header">
        <span class="card-title">课程订单</span>
      </div>
      <div class="flex menu-bar">
        <div class="flex gap12">
          <div style="flex-shrink: 0">姓名</div>
          <el-input
            v-model="searchData.userName"
            clearable
            placeholder="请输入姓名"
          ></el-input>
        </div>
        <div class="flex gap12">
          <div style="flex-shrink: 0">订单号</div>
          <el-input
            v-model="searchData.sn"
            clearable
            placeholder="请输入订单号"
          ></el-input>
        </div>
        <div class="flex">
          <el-button
            size="mini"
            icon="el-icon-search"
            type="warning"
            @click="search"
            >搜索</el-button
          >
          <el-button size="mini" icon="el-icon-search" @click="reset"
            >重置</el-button
          >
        </div>
      </div>
      <div class="card-body">
        <el-table
          :data="orders"
          border
          stripe
          :header-cell-style="{ background: '#fff6e8', color: '#515a6e' }"
        >
          <el-table-column
            type="index"
            label="序号"
            width="50"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="scope">
              <el-button
                type="warning"
                size="mini"
                @click="viewDetail(scope.row)"
                >查看订单信息</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="orderStatus"
            label="订单状态"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag :type="getStatusBtn(scope.row.orderStatus, 'order')">{{
                getStatusType(scope.row.orderStatus, "order")
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="approvalStatus"
            label="审核状态"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag :type="getStatusBtn(scope.row.approvalStatus)">{{
                getStatusType(scope.row.approvalStatus)
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="订单日期"
            width="160"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="sn"
            label="订单号"
            width="180"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="userId"
            label="账号"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="userName"
            label="姓名"
            min-width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="trainingTitle"
            label="课程信息"
            min-width="200"
            align="center"
          >
            <template slot-scope="scope">
              {{
                (scope.row.trainingDetail &&
                  scope.row.trainingDetail.trainingTitle) ||
                ""
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="unitPrice"
            label="费用金额（元）"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <span class="price">{{ scope.row.unitPrice }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="1080px" :show-close="false">
      <div slot="title" class="dialog">
        <div class="flex-between dialog-title">
          <div>查看课程信息</div>
          <i class="el-icon-error" @click="dialogVisible = false"></i>
        </div>
        <div class="title">
          <div class="total">
            合计：<span class="price">￥{{ totalPrice }}</span>
          </div>
        </div>
      </div>
      <el-table
        :data="selectedOrders"
        border
        stripe
        :header-cell-style="{ background: '#fff6e8', color: '#515a6e' }"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="trainingTitle"
          label="课程信息"
          min-width="200"
          align="center"
        >
          <template slot-scope="scope">
            {{
              (scope.row.trainingDetail &&
                scope.row.trainingDetail.trainingTitle) ||
              ""
            }}
          </template>
        </el-table-column>
        <el-table-column prop="unitPrice" label="单价（元）" align="center">
          <template slot-scope="scope">
            <span class="price">{{ scope.row.unitPrice }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="num" label="数量" align="center">
          <template slot-scope="scope">
            <span class="price">{{ scope.row.num }}</span>
          </template>
        </el-table-column>
        <el-table-column label="小计（元）" align="center">
          <template slot-scope="scope">
            <span class="price">{{ scope.row.num * scope.row.unitPrice }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="approvalStatus" label="审核状态" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusBtn(scope.row.approvalStatus)">{{
              getStatusType(scope.row.approvalStatus)
            }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { orderList } from "@/api/course.js";
export default {
  data() {
    return {
      dialogVisible: false,
      orders: [],
      selectedOrders: [],
      searchData: {
        userName: "",
        sn: "",
      },
      currentPage: 1,
    };
  },
  computed: {
    totalPrice() {
      return this.selectedOrders.reduce((total, item) => {
        return total + parseInt(item.unitPrice) * parseInt(item.num);
      }, 0);
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      orderList({
        size: 10,
        ...this.searchData,
      }).then((res) => {
        if (res.data.code == 200) {
          this.orders = res.data.data.records;
        }
        // console.log(res)
      });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    reset() {
      this.searchData = {
        userName: "",
        sn: "",
      };
    },
    getStatusBtn(status, type) {
      let statusMap = {};
      if (type == "order") {
        statusMap = {
          0: "primary",
          1: "info",
        };
      } else {
        statusMap = {
          0: "warning",
          1: "success",
          2: "danger",
          3: "warning",
          4: "info",
        };
      }
      return statusMap[status] || "info";
    },
    getStatusType(status, type) {
      let statusMap = {};
      if (type == "order") {
        statusMap = {
          0: "已提交",
          1: "已取消",
        };
      } else {
        statusMap = {
          0: "审核中",
          1: "审核通过",
          2: "未通过",
          3: "创业中",
          4: "已取消",
        };
      }
      return statusMap[status] || "未知";
    },
    viewDetail(order) {
      this.dialogVisible = true;
      this.selectedOrders = [order];
      // console.log(order)
      // this.$message.info(`查看订单 ${order.sn} 的详情`)
    },
  },
};
</script>

<style lang="less" scoped>
.menu-bar {
  font-size: 14px;
  color: #606266;
  gap: 21px;
}
.gap12 {
  gap: 12px;
}
.course-orders {
  height: 100%;
  .card {
    background: #fff;
    border-radius: 24px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    height: 100%;

    .card-header {
      margin-bottom: 20px;

      .card-title {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
      }
    }

    .price {
      color: #ff6b00;
      font-weight: bold;
    }
  }
  .card-body {
    margin-top: 16px;
  }
}
.dialog {
  .dialog-title {
    font-size: 18px;
    color: #ed9d26;
    font-weight: bold;
    i {
      font-size: 24px;
      color: "#ED9D26";
      cursor: pointer;
    }
  }
  .total {
    font-size: 14px;
    color: #333333;
    margin: 25px 0;
    .price {
      color: #fc0a0a;
    }
  }
}
::v-deep .el-dialog__body {
  padding-top: 0;
}
</style>
